import { render } from "./mianPage.vue?vue&type=template&id=497905aa"
import script from "./mianPage.vue?vue&type=script&lang=js"
export * from "./mianPage.vue?vue&type=script&lang=js"

import "./mianPage.vue?vue&type=style&index=0&id=497905aa&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__